import React from 'react';
import PropTypes from 'prop-types';
import './TabBar.css';

import ActionPrev from './ActionPrev';
import ActionNext from './ActionNext';
import LeftSection from './LeftSection';
import RightSection from './RightSection';
import TabBarMenus from '../custom/-APP_TARGET/content/TabBarMenus';
import SearchAdvanced from './SearchAdvanced';
import ButtonCompactPlayer from '../top-bar/ButtonCompactPlayer';
import ButtonTap from '../top-bar/ButtonTap';

import useRouteTabBar from './hooks/useRouteTabBar';

function TabBar({ style }) {
  const touch = (window.navigator.maxTouchPoints > 0 || window.navigator.msMaxTouchPoints > 0);
  const { leftSection, rightSection } = useRouteTabBar();
  return (
    <div className={`tab-bar`} style={{ ...style }}>
      <ActionPrev />
      <ActionNext />
      { !leftSection ? <TabBarMenus /> : <LeftSection content={leftSection} /> }
      <div className={`flexRow`} style={{ position: 'absolute', right: 390, marginTop: -2 }}>
        { rightSection && <RightSection content={rightSection} /> }
        <ButtonCompactPlayer />
        { touch && <ButtonTap /> }
      </div>
      <SearchAdvanced placeholder={`Start digging...`} className={`search-advanced`} />
    </div>
  )
}

TabBar.propTypes = {
  style: PropTypes.object
}

export default TabBar;
